"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* istanbul ignore next : too simple to test */
function isExprObject(o) {
    return o && typeof o === 'object' && '$expr' in o && Object.keys(o).length === 1;
}
exports.default = isExprObject;
//# sourceMappingURL=isExprObject.js.map